import React from 'react';
import { TRUST_STRIP } from '../data/content';
export function TrustStrip() {
  return <section aria-label="Social proof" className="border-b border-ink-700/60 bg-ink-900" data-id="element-202" data-mp="2o42k4o3semxs">
      <ul className="mx-auto flex max-w-content flex-wrap items-center justify-center gap-x-5 gap-y-1.5 px-5 py-3 text-xs font-semibold text-white/70 sm:text-sm" data-id="element-203" data-mp="2jcue821o1jpd">
        {TRUST_STRIP.map(item => <li key={item.label} className="inline-flex items-center gap-2" data-id="element-204" data-mp="2ac4n3bncohhz">
            <span aria-hidden="true" data-id="element-205" data-mp="2aa1lrvgqz1xy">{item.emoji}</span>
            {item.label}
          </li>)}
      </ul>
    </section>;
}